import { createFileRoute } from "@tanstack/react-router";
import { PrivacyPolicyPage } from "@/app/marketing/PrivacyPolicyPage";

export const Route = createFileRoute("/privacy")({
  component: PrivacyPolicyPage,
});
